// extracted by mini-css-extract-plugin
export default {"container":"CommentModal_container__Ty9oj","text":"CommentModal_text__x2zHT","trim":"CommentModal_trim__xMP20","comment":"CommentModal_comment__yOZ1u"};